import { Component, Input } from '@angular/core';

@Component({
  selector: 'prestamo-bar',
  templateUrl: './prestamo-bar.component.html',
  styleUrls: ['./prestamo-bar.component.css']
})
export class PrestamoBarComponent {
  @Input() icono: string = '';
  @Input() texto: string = 'Préstamo para negocios';
}
